"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tus_js_client_1 = require("tus-js-client");
var util_1 = require("./util");
var render_upload_file_1 = __importDefault(require("./render_upload_file"));
var drop_area_1 = __importDefault(require("./drop_area"));
var s3_uploader_1 = __importDefault(require("./s3_uploader"));
var getFileNameFromUpload = function (upload) {
    if (upload instanceof tus_js_client_1.Upload) {
        return upload.file.name;
    }
    else if (upload instanceof s3_uploader_1.default) {
        return upload.file.name;
    }
    else {
        return upload.original_name || upload.name;
    }
};
var UploadFile = /** @class */ (function () {
    function UploadFile(_a) {
        var callbacks = _a.callbacks, chunkSize = _a.chunkSize, eventEmitter = _a.eventEmitter, fieldName = _a.fieldName, form = _a.form, formId = _a.formId, s3UploadDir = _a.s3UploadDir, initial = _a.initial, input = _a.input, multiple = _a.multiple, parent = _a.parent, prefix = _a.prefix, retryDelays = _a.retryDelays, skipRequired = _a.skipRequired, supportDropArea = _a.supportDropArea, translations = _a.translations, uploadUrl = _a.uploadUrl;
        var _this = this;
        this.uploadFiles = function (files) {
            if (files.length === 0) {
                return;
            }
            if (!_this.multiple && _this.uploads.length !== 0) {
                _this.renderer.deleteFile(0);
                _this.uploads = [];
            }
            files.forEach(function (file) {
                _this.uploadFile(file);
            });
            _this.checkDropHint();
        };
        this.onChange = function (e) {
            var files = [];
            files = Array.from(e.target.files || []);
            _this.uploadFiles(__spreadArray([], __read(files), false));
        };
        this.onClick = function (e) {
            var target = e.target;
            var getUploadIndex = function () {
                var dataIndex = target.getAttribute("data-index");
                if (!dataIndex) {
                    return null;
                }
                return parseInt(dataIndex, 10);
            };
            if (target.classList.contains("dff-delete") &&
                !target.classList.contains("dff-disabled")) {
                var uploadIndex = getUploadIndex();
                if (uploadIndex !== null) {
                    _this.removeExistingUpload(uploadIndex);
                }
                e.preventDefault();
            }
            else if (target.classList.contains("dff-cancel")) {
                var uploadIndex = getUploadIndex();
                if (uploadIndex !== null) {
                    _this.handleCancel(uploadIndex);
                }
                e.preventDefault();
            }
        };
        this.handleProgress = function (uploadIndex, bytesUploaded, bytesTotal) {
            var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
            _this.renderer.updateProgress(uploadIndex, percentage);
            var onProgress = _this.callbacks.onProgress;
            if (onProgress) {
                var upload = _this.uploads[uploadIndex];
                if (upload instanceof tus_js_client_1.Upload) {
                    onProgress(bytesUploaded, bytesTotal, upload);
                }
            }
        };
        this.handleError = function (uploadIndex, error) {
            _this.renderer.setError(uploadIndex);
            _this.uploadStatuses[uploadIndex] = "error";
            var onError = _this.callbacks.onError;
            if (onError) {
                var upload = _this.uploads[uploadIndex];
                if (upload instanceof tus_js_client_1.Upload) {
                    onError(error, upload);
                }
            }
        };
        this.handleSuccess = function (uploadIndex, uploadedSize) {
            var renderer = _this.renderer;
            _this.updateS3UploadedInput();
            renderer.clearInput();
            renderer.setSuccess(uploadIndex, uploadedSize);
            _this.uploadStatuses[uploadIndex] = "done";
            var onSuccess = _this.callbacks.onSuccess;
            var upload = _this.uploads[uploadIndex];
            var element = document.getElementsByClassName("dff-file-id-".concat(uploadIndex))[0];
            _this.emitEvent("uploadComplete", element, upload);
            if (onSuccess) {
                var upload_1 = _this.uploads[uploadIndex];
                if (upload_1 instanceof tus_js_client_1.Upload) {
                    onSuccess(upload_1);
                }
            }
        };
        this.callbacks = callbacks;
        this.chunkSize = chunkSize;
        this.eventEmitter = eventEmitter;
        this.fieldName = fieldName;
        this.form = form;
        this.formId = formId;
        this.s3UploadDir = s3UploadDir;
        this.multiple = multiple;
        this.prefix = prefix;
        this.retryDelays = retryDelays;
        this.supportDropArea = supportDropArea;
        this.uploadUrl = uploadUrl;
        this.uploadIndex = 0;
        this.uploads = [];
        this.uploadStatuses = [];
        this.renderer = new render_upload_file_1.default({
            parent: parent,
            input: input,
            skipRequired: skipRequired,
            translations: translations
        });
        var filesContainer = this.renderer.container;
        if (supportDropArea) {
            this.initDropArea(filesContainer, input.accept);
        }
        if (initial) {
            this.addInitialFiles(initial);
        }
        this.checkDropHint();
        input.addEventListener("change", this.onChange);
        filesContainer.addEventListener("click", this.onClick);
    }
    UploadFile.prototype.addInitialFiles = function (initialFiles) {
        var _this = this;
        if (initialFiles.length === 0) {
            return;
        }
        var _a = this, multiple = _a.multiple, renderer = _a.renderer;
        var addInitialFile = function (file, i) {
            var id = file.id, name = file.name, size = file.size;
            var element = renderer.addUploadedFile(file.original_name ? file.original_name : name, i, size);
            var upload;
            if (file.placeholder === true) {
                // in case of placeholder
                upload = { id: id, name: name, placeholder: true, size: size };
            }
            else if (file.placeholder === false) {
                // in case of S3
                upload = {
                    id: id,
                    name: name,
                    placeholder: false,
                    size: size,
                    original_name: file.original_name
                };
            }
            else {
                // in case of regular UploadedFile
                var url = "".concat(_this.uploadUrl).concat(file.id);
                upload = { id: id, name: name, size: size, url: url };
            }
            _this.uploads.push(upload);
            _this.uploadStatuses.push("done");
            _this.emitEvent("addUpload", element, upload);
        };
        if (multiple) {
            var uploadIndex_1 = 0;
            initialFiles.forEach(function (file) {
                addInitialFile(file, uploadIndex_1);
                uploadIndex_1 += 1;
            });
        }
        else {
            addInitialFile(initialFiles[0], 0);
        }
    };
    UploadFile.prototype.uploadFile = function (file) {
        var _this = this;
        var _a = this, fieldName = _a.fieldName, formId = _a.formId, s3UploadDir = _a.s3UploadDir, renderer = _a.renderer, uploads = _a.uploads, uploadUrl = _a.uploadUrl;
        var filename = file.name;
        var existingUploadIndex = this.findUpload(filename);
        if (existingUploadIndex !== null) {
            this.removeExistingUpload(existingUploadIndex);
        }
        var uploadIndex = uploads.length;
        var upload = null;
        if (s3UploadDir != null) {
            upload = new s3_uploader_1.default(file, {
                s3UploadDir: s3UploadDir,
                endpoint: uploadUrl,
                onProgress: function (bytesUploaded, bytesTotal) {
                    return _this.handleProgress(uploadIndex, bytesUploaded, bytesTotal);
                },
                onError: function (error) { return _this.handleError(uploadIndex, error); },
                onSuccess: function () {
                    return _this.handleSuccess(uploadIndex, upload.file.size);
                }
            });
        }
        else {
            upload = new tus_js_client_1.Upload(file, {
                chunkSize: this.chunkSize,
                endpoint: uploadUrl,
                metadata: { fieldName: fieldName, filename: filename, formId: formId },
                onError: function (error) { return _this.handleError(uploadIndex, error); },
                onProgress: function (bytesUploaded, bytesTotal) {
                    return _this.handleProgress(uploadIndex, bytesUploaded, bytesTotal);
                },
                onSuccess: function () {
                    return _this.handleSuccess(uploadIndex, upload.file.size);
                },
                retryDelays: this.retryDelays || [0, 1000, 3000, 5000]
            });
        }
        upload.start();
        var element = renderer.addNewUpload(filename, uploadIndex);
        this.uploads.push(upload);
        this.uploadStatuses.push("uploading");
        this.emitEvent("addUpload", element, upload);
    };
    UploadFile.prototype.findUpload = function (filename) {
        var upload = this.uploads.find(function (upload) {
            var _a, _b;
            if (upload instanceof tus_js_client_1.Upload) {
                return ((_b = (_a = upload.options) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.filename) === filename;
            }
            else if (upload instanceof s3_uploader_1.default) {
                return upload.file.name === filename;
            }
            else if (upload) {
                return upload.name === filename;
            }
            else {
                return false;
            }
        });
        var index = this.uploads.indexOf(upload);
        return index >= 0 ? index : null;
    };
    UploadFile.prototype.removeExistingUpload = function (uploadIndex) {
        var uploadStatus = this.uploadStatuses[uploadIndex];
        if (uploadStatus === "uploading") {
            var upload_2 = this.uploads[uploadIndex];
            void upload_2.abort(true);
        }
        var upload = this.uploads[uploadIndex];
        if (!upload) {
            return;
        }
        var element = this.renderer.findFileDiv(uploadIndex);
        if (element) {
            this.emitEvent("removeUpload", element, upload);
        }
        if (upload instanceof tus_js_client_1.Upload ||
            upload instanceof s3_uploader_1.default ||
            upload.url) {
            var uploadStatus_1 = this.uploadStatuses[uploadIndex];
            switch (uploadStatus_1) {
                case "done": {
                    if (upload instanceof s3_uploader_1.default) {
                        this.deleteS3Uploaded(uploadIndex);
                    }
                    else {
                        this.deleteFromServer(uploadIndex);
                    }
                    break;
                }
                case "error": {
                    this.removeUploadFromList(uploadIndex);
                    break;
                }
                case "uploading": {
                    var upload_3 = this.uploads[uploadIndex];
                    void upload_3.abort(true);
                    this.removeUploadFromList(uploadIndex);
                    break;
                }
            }
        }
        else if (upload.placeholder) {
            this.deletePlaceholder(uploadIndex);
        }
    };
    UploadFile.prototype.removeUploadFromList = function (uploadIndex) {
        var upload = this.uploads[uploadIndex];
        if (!upload) {
            return;
        }
        this.renderer.deleteFile(uploadIndex);
        delete this.uploads[uploadIndex];
        delete this.uploadStatuses[uploadIndex];
        this.checkDropHint();
        var onDelete = this.callbacks.onDelete;
        if (onDelete) {
            onDelete(upload);
        }
    };
    UploadFile.prototype.deleteFromServer = function (uploadIndex) {
        var _this = this;
        var upload = this.uploads[uploadIndex];
        if (!upload) {
            return;
        }
        var url = upload.url;
        if (!url) {
            return;
        }
        this.renderer.disableDelete(uploadIndex);
        var xhr = new window.XMLHttpRequest();
        xhr.open("DELETE", url);
        xhr.onload = function () {
            if (xhr.status === 204) {
                _this.removeUploadFromList(uploadIndex);
            }
            else {
                _this.renderer.setDeleteFailed(uploadIndex);
            }
        };
        xhr.setRequestHeader("Tus-Resumable", "1.0.0");
        xhr.send(null);
    };
    UploadFile.prototype.deletePlaceholder = function (uploadIndex) {
        this.removeUploadFromList(uploadIndex);
        this.updatePlaceholderInput();
    };
    UploadFile.prototype.deleteS3Uploaded = function (uploadIndex) {
        this.removeUploadFromList(uploadIndex);
        this.updateS3UploadedInput();
    };
    UploadFile.prototype.handleCancel = function (uploadIndex) {
        var upload = this.uploads[uploadIndex];
        if (upload instanceof tus_js_client_1.Upload) {
            void upload.abort(true);
            this.removeUploadFromList(uploadIndex);
        }
        else if (upload instanceof s3_uploader_1.default) {
            upload.abort();
            this.removeUploadFromList(uploadIndex);
        }
    };
    UploadFile.prototype.initDropArea = function (container, inputAccept) {
        new drop_area_1.default({
            container: container,
            inputAccept: inputAccept,
            onUploadFiles: this.uploadFiles
        });
    };
    UploadFile.prototype.checkDropHint = function () {
        if (!this.supportDropArea) {
            return;
        }
        var nonEmptyUploads = this.uploads.filter(function (e) { return e; });
        if (nonEmptyUploads.length === 0) {
            this.renderer.renderDropHint();
        }
        else {
            this.renderer.removeDropHint();
        }
    };
    UploadFile.prototype.updatePlaceholderInput = function () {
        var placeholdersInfo = this.uploads.filter(function (upload) {
            return upload &&
                !(upload instanceof tus_js_client_1.Upload) &&
                !(upload instanceof s3_uploader_1.default) &&
                upload.placeholder;
        });
        var input = (0, util_1.findInput)(this.form, (0, util_1.getPlaceholderFieldName)(this.fieldName, this.prefix), this.prefix);
        if (input) {
            input.value = JSON.stringify(placeholdersInfo);
        }
    };
    UploadFile.prototype.updateS3UploadedInput = function () {
        // upload could be
        // 1. A regular Upload object
        // 2. A map object with .placeholder == true
        // 3. A map object with .placeholder == false, created when the form is reloaded
        // 4. An S3Uploader object that will need to be saved as UploadedFile
        // the latter two cases are handled here
        var s3Uploads = this.uploads
            .filter(function (upload) { return upload instanceof s3_uploader_1.default; })
            .map(function (upload) {
            var s3Upload = upload;
            return {
                id: s3Upload.uploadId,
                name: s3Upload.key,
                placeholder: false,
                size: s3Upload.file.size,
                original_name: s3Upload.file.name
            };
        });
        var uploadedInfo = this.uploads
            .filter(function (upload) {
            return upload &&
                !(upload instanceof tus_js_client_1.Upload) &&
                !(upload instanceof s3_uploader_1.default) &&
                upload.placeholder === false;
        })
            .concat(s3Uploads);
        var input = (0, util_1.findInput)(this.form, (0, util_1.getS3UploadedFieldName)(this.fieldName, this.prefix), this.prefix);
        if (input) {
            input.value = JSON.stringify(uploadedInfo);
        }
    };
    UploadFile.prototype.getMetaDataField = function () {
        return (0, util_1.findInput)(this.form, (0, util_1.getMetadataFieldName)(this.fieldName, this.prefix), this.prefix);
    };
    UploadFile.prototype.emitEvent = function (eventName, element, upload) {
        if (this.eventEmitter) {
            this.eventEmitter.emit(eventName, {
                element: element,
                fieldName: this.fieldName,
                fileName: getFileNameFromUpload(upload),
                metaDataField: this.getMetaDataField(),
                upload: upload
            });
        }
    };
    return UploadFile;
}());
exports.default = UploadFile;
